




import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Tutorial from './docs-main/blog-pages/Tutorial.vue';
import TutorialFolder from './docs-main/reference-pages/TutorialFolder.vue';
import SearchPage from '@/components/docs-main/search/SearchPage.vue';
import TutorialsPage from './docs-main/blog-pages/Tutorials.vue';
import ReferencesPage from './docs-main/reference-pages/References.vue';
import HowtosPage from './docs-main/blog-pages/HowTos.vue';
import { Getter, State } from 'vuex-class';
import { currentInstance } from '@/heplers';

@Component({
  components: {
    SearchPage,
    TutorialFolder,
    TutorialsPage,
    HowtosPage,
    ReferencesPage,
    Tutorial,
  },
})
export default class ComputeLayoutComponent extends Vue {
  @State('pageRendered') pageRendered: boolean;
  @Getter('getContent') content: any;

  get isSearchPage() {
    return this.$route.name === 'Search';
  }

  get isReferencesPage() {
    return currentInstance === 'vox'
      ? this.$route.meta.fqdn === 'references'
      : this.$route.meta.fqdn === 'references' || this.$route.name === 'Voximplant Kit';
  }

  get isHowtosPage() {
    return this.$route.meta.fqdn === 'howtos';
  }

  get isTutorialPage() {
    const tutorialKinds = ['tutorial', 'howto', 'changelog'];
    const tutorialsFolderFqdn = ['howtos', 'tutorials', 'changelog'];
    const metaSplit = this.$route.meta.fqdn.split('.');

    if (this.content?.kind === 'folder') return false;

    // For tutorials Page inside References
    if (tutorialKinds.includes(this.content?.kind) && metaSplit.length > 1) return true;

    // For other
    return tutorialsFolderFqdn.includes(metaSplit[0]) && metaSplit.length > 1;
  }

  get computeNameComponent() {
    if (this.isReferencesPage) return 'ReferencesPage';

    if (!this.content && !this.isSearchPage) return 'Tutorial';

    if (this.isSearchPage) return 'SearchPage';

    if (this.isTutorialPage) return 'Tutorial';

    if (this.isHowtosPage) return 'HowtosPage';

    return 'TutorialFolder';
  }
}
